import { register } from '@shopify/theme-sections';
Avatar.theme = Avatar.theme || {};
Avatar.theme.sections = Avatar.theme.sections || {};

Avatar.theme.sections.register = function Sections() {
  register('product-template', {
    onLoad: function onLoad() {
      Avatar.theme.Product.init();
    },
    onUnload: function onUnload() {
      Avatar.theme.Product.destroy();
    }
  });
  register('blog-template', {
    onLoad: function onLoad() {
      Avatar.theme.BlogTagFilter.filterByTag();
    }
  });
}();